import { ColorBadge, Theme as theme } from '@spoiler-alert/ui-library';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import { BreadcrumbsStore } from '../store';
import { Breadcrumb } from '../store/breadcrumbsStore';

const useStyles = createUseStyles({
  breadcrumbWrapper: {
    padding: 16,
    fontSize: 16,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '&:hover': {
      overflow: 'visible',
      marginRight: '-16%',
      zIndex: 1,
      background: 'white',
    },
  },
  breadcrumbSpan: {
    '&:after': {
      content: '" / "',
    },
    '&:last-child': {
      '&>a': {
        color: theme.textColorPrimary,
        '&:hover': {
          cursor: 'pointer',
        },
      },
      '&:after': {
        content: '""',
      },
    },
  },
});

interface BreadcrumbsProps {
  breadcrumbsStore: BreadcrumbsStore;
}

function Breadcrumbs({ breadcrumbsStore }: BreadcrumbsProps) {
  const classes = useStyles();

  const Badge = ({ bc }: { bc: Breadcrumb }): React.ReactElement => {
    return (
      <div style={{ marginLeft: 12, display: 'inline-block' }}>
        <ColorBadge id={bc.url} theme={bc.badge?.color} tooltipText={bc.badge?.tooltip || undefined} Icon={bc.badge?.icon}>
          {bc.badge?.text}
        </ColorBadge>
      </div>
    );
  };
  return (
    <div className={classes.breadcrumbWrapper}>
      {breadcrumbsStore.breadcrumbs.map((bc) => (
        <span key={bc.url} className={classes.breadcrumbSpan}>
          {bc.url ? <Link to={bc.url}>{bc.title}</Link> : <a>{bc.title}</a>}
          {bc.badge && <Badge bc={bc} />}
        </span>
      ))}
    </div>
  );
}

export default inject((store) => store)(observer(Breadcrumbs));
